import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

export const DialogContentDefaultPadding: React.CSSProperties = {
    marginBottom: TabStyles.Spacing.MediumSpace
};

export const DialogTextFieldStyle = style({
    flexGrow: 1,
    $nest: {
      '& input': {
        width: '100%'
      }
    }
  });

export const DialogUrlStyle: React.CSSProperties = {
    ...DialogContentDefaultPadding,
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'left',
    overflow: 'hidden',
    wordWrap: 'break-word'
};

export const DialogFieldParentStyle: React.CSSProperties = {
  ...DialogContentDefaultPadding,
  display: 'flex'
};

export const toolTipStyle: React.CSSProperties = {
  display:'flex',
  justifyContent:'flex-end',
  alignItems:'center', gap:5
};